export let domain = 'https://rent-car.twilightparadox.com/api';
// export let domain = 'http://localhost:4000/api';
